module.exports = __webpack_public_path__ + "static/media/arrow_downward.7bd8b7e4.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/arrow_downward.svg
// module id = 1981
// module chunks = 0